import { Head } from 'shared/page/Head';

import { buildCommonProps } from '@/server/data/';
import getConfig from 'next/config';
import ResultMap from '@/scenes/resultPage/containers/resultMap/ResultMap';

const {
    publicRuntimeConfig: { baseUrl },
} = getConfig();

const MapPage = (props) => (
    <>
        <Head
            title="Feriehjem og hytter - sammenlign pris | FINN reise"
            description="Finn tusenvis av feriehjem og hytter på et sted!"
            canonical={`${baseUrl}/reise/feriehus-hytteutleie/kart/`}
        />
        <main>
            <ResultMap {...props} />
        </main>
    </>
);

export const getServerSideProps = async ({ req, res, query }) => {
    const commonProps = await buildCommonProps(req, res, query);

    return {
        props: {
            ...commonProps,
        },
    };
};

export default MapPage;
